exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".incomeList li[data-v-bff1737a]{padding:10px;border-top:1px solid #eee}.incomeList .money[data-v-bff1737a]{float:right;width:60px;height:30px;line-height:30px;color:#fb8d00;text-align:right;font-size:18px}.incomeList .content[data-v-bff1737a]{padding-right:70px}.incomeList h4[data-v-bff1737a]{font-weight:400}.incomeList p[data-v-bff1737a]{font-size:11px}.incomeList .time[data-v-bff1737a]{color:#999;margin-top:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-bff1737a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modular/expend.vue
// module id = 445
// module chunks = 0